import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getInsightApi,
  getProfitLossApi,
} from "../../apis/insightAdvanvedApis";
import {
  InsightsAdvancedPayload,
  ProfitLossPayload,
} from "../../commonTypes/insightAdvancedTypes";

export const getInsightsAdvancedAction = createAsyncThunk(
  "insightAdvancedSalesCurrent",
  async (data: InsightsAdvancedPayload) => {
    const response = await getInsightApi(data);
    return response.data;
  }
);

export const getInsightsAdvancedSalesAction = createAsyncThunk(
  "insightAdvancedTotalSalesCurrent",
  async (data: InsightsAdvancedPayload) => {
    const response = await getInsightApi(data);
    return response.data;
  }
);

export const getInsightsAdvancedExpenseAction = createAsyncThunk(
  "insightAdvancedTotalExpenseCurrent",
  async (data: InsightsAdvancedPayload) => {
    const response = await getInsightApi(data);
    return response.data;
  }
);

export const profitLossAction = createAsyncThunk(
  "profitLoss",
  async (data: ProfitLossPayload) => {
    const response = await getProfitLossApi(data);
    return response.data;
  }
);
